import React from 'react';
import { IconContainer } from './IconContainer';

const ShcIcon = (props) => {
    return (
        <IconContainer ariaLabel="tools" {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 12H7V21H3V12ZM17 8H21V21H17V8ZM10 2H14V21H10V2Z">
                </path>
            </svg>
        </IconContainer>
    )
}

export { ShcIcon };